import { render } from "./MCType.vue?vue&type=template&id=1722ce2b&scoped=true"
import script from "./MCType.vue?vue&type=script&lang=js"
export * from "./MCType.vue?vue&type=script&lang=js"

import "./MCType.vue?vue&type=style&index=0&id=1722ce2b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aarhondakis\\Desktop\\lernapp_quellcode\\lernapp-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1722ce2b"]])

export default __exports__